/* eslint-disable */ 
import Vue from "vue";
import Vuex from "vuex";

// Importing modules
import auth from './modules/auth';
import maps from './modules/maps';



Vue.use(Vuex);

export default new Vuex.Store({
  
  modules: {
    auth,
    maps
  },
});
